import React, { useMemo } from 'react';
import { Pagination, Select } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const { Option } = Select;

const CustomMinimalPagination = ({ currentPage, setCurrentPage, pageSize, setPageSize, setOffset, totalItems }) => {
  const totalPages = Math.ceil(totalItems / pageSize); // Calculate total pages

  const handlePageChange = (page, newPageSize) => {
    setCurrentPage(page);
    setPageSize(newPageSize);
    setOffset(newPageSize * (page - 1));
  };

  const handlePageSizeChange = (newPageSize) => {
    setCurrentPage(1);
    setPageSize(newPageSize);
    setOffset(0);
  };

  const { rangeStart, rangeEnd } = useMemo(() => {
    const start = (currentPage - 1) * pageSize + 1;
    const end = Math.min(currentPage * pageSize, totalItems);
    return { rangeStart: start, rangeEnd: end };
  }, [currentPage, pageSize, totalItems]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '16px' }}>
      {/* Previous Arrow */}
      <LeftOutlined
        onClick={() => currentPage > 1 && handlePageChange(currentPage - 1, pageSize)}
        style={{ cursor: currentPage > 1 ? 'pointer' : 'not-allowed', opacity: currentPage > 1 ? 1 : 0.5 }}
      />

      {/* Page Number Display */}
      <span>{currentPage} / {totalPages}</span>

      {/* Next Arrow */}
      <RightOutlined
        onClick={() => currentPage < totalPages && handlePageChange(currentPage + 1, pageSize)}
        style={{ cursor: currentPage < totalPages ? 'pointer' : 'not-allowed', opacity: currentPage < totalPages ? 1 : 0.5 }}
      />
      {/* Range Display */}
      {/* <span>{`${rangeStart}-${rangeEnd} out of ${totalItems}`}</span> */}
      <Select value={pageSize} onChange={handlePageSizeChange} style={{ width: 115 }}>
        {[25, 50, 100].map(size => (
          <Option key={size} value={size}>{size} / page</Option>
        ))}
      </Select>
      {/* Hidden Ant Design Pagination (for page size changing) */}
      <Pagination
        current={currentPage}
        pageSize={pageSize}
        total={totalItems}
        showSizeChanger
        pageSizeOptions={['25', '50', '100']}
        onChange={handlePageChange}
        simple
        style={{ display: 'none' }} // Hide the default Ant Design pagination UI
      />
    </div>
  );
};

export default CustomMinimalPagination;
